"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Milestone = {
  year: string;
  title: string;
  description: string;
};
const milestones: Milestone[] = [{
  year: "2012",
  title: "InfraPM established for public sector support",
  description: "Founded to bridge the gap between complex infrastructure planning and municipal execution, focusing on grant-funded project delivery for local agencies."
}, {
  year: "2016",
  title: "Expansion into regional compliance coordination",
  description: "Developed a specialized framework for multi-jurisdictional compliance, ensuring that regional infrastructure projects meet rigorous state and federal regulatory standards."
}, {
  year: "2019",
  title: "Launch of integrated project management suite",
  description: "Introduced a proprietary project tracking system that aligns financial reporting with construction milestones, providing transparency for public stakeholders."
}, {
  year: "2024",
  title: "Strategic implementation for sustainable growth",
  description: "Scaling our hands-on implementation services to support counties in long-term infrastructure resilience, focusing on climate-ready public works and utility upgrades."
}];
function MilestoneRow({
  milestone,
  index
}: {
  milestone: Milestone;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div data-index={index} ref={ref} className="group relative" style={{
    transition: "opacity 520ms cubic-bezier(0.2, 0.7, 0.2, 1), transform 520ms cubic-bezier(0.2, 0.7, 0.2, 1)",
    transitionDelay: `${index * 100}ms`,
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(16px)"
  }}>
      {}
      <div className="relative w-full">
        <div className="h-px bg-border transition-[width] duration-300 ease-out group-hover:w-[calc(100%+2rem)]" style={{
        width: "100%",
        transitionTimingFunction: "cubic-bezier(0.2, 0.7, 0.2, 1)"
      }} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 md:gap-8 pt-8 md:pt-10 pb-10 md:pb-12">
        {}
        <div className="md:col-span-2">
          <div className="text-xs font-default font-semibold uppercase tracking-[0.14em] text-muted-foreground mb-3 md:hidden">
            Year
          </div>
          <div className="font-default font-semibold leading-[1.1] text-foreground transition-colors duration-200 ease-out group-hover:text-chart-2 text-2xl md:text-[2rem]" style={{
          letterSpacing: "-0.012em"
        }}>
            {milestone.year}
          </div>
        </div>

        {}
        <div className="md:col-span-8 mt-4 md:mt-0">
          <h3 className="font-default font-medium text-foreground text-xl md:text-[1.375rem] leading-[1.25]" style={{
          letterSpacing: "-0.005em"
        }}>
            {milestone.title}
          </h3>
          <p className="mt-4 font-default font-normal text-muted-foreground text-base md:text-[1.0625rem] leading-[1.55]" style={{
          letterSpacing: "-0.003em"
        }}>
            {milestone.description}
          </p>
        </div>

        {}
        <div className="hidden md:block md:col-span-2" aria-hidden="true" />
      </div>
    </div>;
}
export default function Milestones() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}